<template>
	<div>
		<div class="search search--header header__search">
		   <form id="search-top" name="searchform" :action="actionUrl" method="get">
		      <input name="q" id="searchfield1" ref="search" type="text" maxlength="200" v-model="searchInput" style="border-radius: 24px 0 0 24px;" value="" placeholder="Search..." aria-label="Search" />
		      <span v-if="searchClear" class="btn--clear" aria-label="Clear"><span id="quick-clear" v-on:click="clearSearch" class="icon icon--clear"></span></span>
		      <button class="btn--search" type="submit" style="border-radius: 0 24px 24px 0;" id="quick-search-top" aria-label="Search"><span class="icon icon--search"></span></button>
		      <input type="hidden" name="type" v-model="typeName">
		   </form>
		</div>
		<nav class="nav nav--header-bottom header__bottom">
		   <ul class="menu">
		   		<li :class="activeClass('web')"><a class="menu__link" v-on:click="toggleActive('web')" :href="generateUrl('web')">Web</a></li>
		   		<li :class="activeClass('testimonial')"><a class="menu__link" v-on:click="toggleActive('testimonial')" :href="generateUrl('testimonial')">Testimonials</a></li>
		   		<li :class="activeClass('scientific')"><a class="menu__link" v-on:click="toggleActive('scientific')" :href="generateUrl('scientific')">Scientific Research</a></li>		   		
		   </ul>
		</nav>
	</div>
</template>

<script>
	export default {
		props: ['data'],
		data() {
			return {
				searchInput: this.data.q,
				searchType: this.data.type,	
				typeName: this.data.type,
				actionUrl: window.location.origin + '/search',
				searchClear: true,
				searchByCategory: (this.data.cat_id) ? '&cat_id=' + this.data.cat_id : '',
				searchBySubCategory: (this.data.sub_id) ? '&sub_id=' + this.data.sub_id : '',
			};
		},
		mounted() {
		},
		methods: {
			activeClass(segment) {
				return segment == this.searchType ? 'menu__item is-active' : 'menu__item'
			},
			toggleActive (index) {
				this.searchType = index;
				this.typeName = index;
			},
			clearSearch() {
				this.searchClear = false;
				this.searchInput = "";
				this.$refs.search.focus();
			}, 
			generateUrl(typeName) {
				if (this.searchInput !== null) {
					var url = 'search?q=' + this.searchInput + '&type=' + typeName + this.searchByCategory + this.searchBySubCategory;
				}
				else {
					var url = 'search?type=' + typeName + this.searchByCategory + this.searchBySubCategory;
				}
				return url;				
			},     	
		},
		computed: {
		},   
	}
</script>

